import {
  BookedWorkCell,
  type LedgerCollapse,
  type LedgerColumn,
} from '@billda/design-system';

/**
 * Column and collapse setup for the pot breakdown ledger. The screen owns the
 * CSS container the collapse point reads, so the name lives here too.
 */

export const POT_LEDGER_CONTAINER = 'pot-breakdown';

/**
 * One collapse point: below it every column hides and rows grow a meta line.
 * Four columns need the same room activity's four need, so the point is the
 * same 760 rather than the 620 the three-column layout used.
 */
export const POT_LEDGER_COLLAPSE: LedgerCollapse = {
  container: POT_LEDGER_CONTAINER,
  at: 760,
};

/**
 * Activity's columns exactly. Site names truncate in the Site / Plot cell and
 * the plot number never does; a row scoped to a whole site shows the site
 * alone, and an org-level deduction leaves the cell empty.
 */
export const POT_LEDGER_COLUMNS: LedgerColumn[] = [
  { key: BookedWorkCell.Ref, label: 'Ref', flex: 0.8 },
  { key: BookedWorkCell.SitePlot, label: 'Site / Plot', flex: 1.9 },
  { key: BookedWorkCell.BookedBy, label: 'Booked by', flex: 1.1 },
  { key: BookedWorkCell.When, label: 'When', flex: 1 },
];
